class CartUpsell extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.cart-upsell__track');
    if (!this.track) return;

    this.querySelector('[name="previous"]')?.addEventListener('click', () => this.go(-1));
    this.querySelector('[name="next"]')?.addEventListener('click', () => this.go(1));

    // <add-to-cart> only listens for clicks, so let Enter and Space activate the "+" button too.
    this.addEventListener('keydown', (event) => {
      const button = event.target.closest('add-to-cart');
      if (!button || (event.key !== 'Enter' && event.key !== ' ')) return;

      event.preventDefault();
      if (!button.classList.contains('loading')) button.click();
    });
  }

  // Moves one product at a time and wraps around at either end.
  go(direction) {
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    const position = this.track.scrollLeft;

    if (direction > 0 && position >= maxScroll - 1) {
      this.track.scrollTo({ left: 0 });
    } else if (direction < 0 && position <= 1) {
      this.track.scrollTo({ left: maxScroll });
    } else {
      this.track.scrollBy({ left: direction * this.track.clientWidth });
    }
  }
}
customElements.define('cart-upsell', CartUpsell);
